.aggregateCards {
  margin-bottom: 0.5rem !important;
}

@media (min-width: 30em) {
  .aggregateCard {
    width: calc(100%/1.1) !important;
  }
}

@media (min-width: 48em) {
  .aggregateCard {
    width: calc(100%/2.1) !important;
  }
}

@media (min-width: 64em) {
  .aggregateCard {
    width: calc(100%/4.1) !important;
  }
}

@media (min-width: 80em) {

}
